var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    {
      staticClass: "bg-primary",
      attrs: { toggleable: "md", type: "dark", "data-cy": "navbar" }
    },
    [
      _c("b-row", [
        _c(
          "div",
          { staticClass: "jh-logo-container", attrs: { "my-auto": "" } },
          [
            _vm.hasAnyAuthority("ROLE_ADMIN")
              ? _c(
                  "div",
                  {
                    staticClass: "icon-sidebar",
                    attrs: { id: "sidebar-icon", exact: "" }
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "b-toggle",
                            rawName: "v-b-toggle.sidebar-footer",
                            modifiers: { "sidebar-footer": true }
                          }
                        ]
                      },
                      [
                        _c(
                          "b-button",
                          { attrs: { variant: "outline-primary" } },
                          [
                            _c("font-awesome-icon", {
                              staticClass: "fa-lg",
                              attrs: { icon: "ellipsis-v" }
                            }),
                            _vm._v(" "),
                            _c("font-awesome-icon", {
                              staticClass: "fa-lg",
                              attrs: { icon: "ellipsis-v" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-navbar-brand",
              { staticClass: "logo", attrs: { "b-link": "", to: "/" } },
              [
                _c("span", { staticClass: "logo-img" }),
                _vm._v(" "),
                _c("span", { staticClass: "navbar-title" }, [
                  _c("span", { staticClass: "jhipster-title" }, [
                    _vm._v("JHipster")
                  ]),
                  _vm._v(" Control Center")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "navbar-version" }, [
                  _vm._v(_vm._s(_vm.version))
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "b-navbar-toggle",
              {
                staticClass: "jh-navbar-toggler d-lg-none",
                attrs: {
                  right: "",
                  href: "javascript:void(0);",
                  "data-toggle": "collapse",
                  target: "header-tabs",
                  "aria-expanded": "false",
                  "aria-label": "Toggle navigation"
                }
              },
              [_c("font-awesome-icon", { attrs: { icon: "bars" } })],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-collapse",
        { attrs: { "is-nav": "", id: "header-tabs" } },
        [
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c("b-nav-item", { attrs: { to: "/", exact: "" } }, [
                _c(
                  "span",
                  [
                    _c("font-awesome-icon", { attrs: { icon: "home" } }),
                    _vm._v(" "),
                    _c("span", [_vm._v("Home")])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-nav-item-dropdown",
                {
                  staticClass: "pointer",
                  class: { "router-link-active": _vm.subIsActive("/account") },
                  attrs: {
                    right: "",
                    href: "javascript:void(0);",
                    id: "account-menu",
                    "active-class": "active",
                    "data-cy": "accountMenu"
                  }
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "navbar-dropdown-menu",
                      attrs: { slot: "button-content" },
                      slot: "button-content"
                    },
                    [
                      _c("font-awesome-icon", { attrs: { icon: "user" } }),
                      _vm._v(" "),
                      _c("span", { staticClass: "no-bold" }, [
                        _vm._v(" Account ")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            "data-cy": "logout",
                            id: "logout",
                            "active-class": "active"
                          },
                          on: {
                            click: function($event) {
                              return _vm.logout()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-out-alt" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Sign out")])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.authenticated
                    ? _c(
                        "b-dropdown-item",
                        {
                          attrs: {
                            "data-cy": "login",
                            id: "login",
                            "active-class": "active"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openLogin()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "sign-in-alt" }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Sign in")])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }